import React from 'react'
import { css } from 'styled-components'
import { Card } from 'rebass'
import PropTypes from 'prop-types'
import imgsrc from '../../images/image-optim.jpg'

export const Background = ({ children }) => (
  <Card
    backgroundImage={`url(${imgsrc})`}
    backgroundSize="cover"
    backgroundRepeat="no-repeat"
    css={css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      z-index: -1;
    `}
  >
    {children}
  </Card>
)

Background.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}
